import React from 'react';
import { useSubscription } from '../../context/SubscriptionContext';

export const TrialBanner: React.FC = () => {
  const { isTrial, trialDaysRemaining } = useSubscription();

  if (!isTrial) return null;

  const isUrgent = trialDaysRemaining <= 2;

  return (
    <div style={{
      padding: '10px 16px',
      background: isUrgent
        ? 'linear-gradient(135deg, #ef4444, #dc2626)'
        : 'linear-gradient(135deg, #8b5cf6, #6366f1)',
      borderRadius: '10px',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '13px',
      marginBottom: '16px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '16px' }}>&#x1F451;</span>
        <span>
          {isUrgent
            ? `Tu trial Premium expira en ${trialDaysRemaining} dia${trialDaysRemaining !== 1 ? 's' : ''}!`
            : `Trial Premium: ${trialDaysRemaining} dia${trialDaysRemaining !== 1 ? 's' : ''} restantes`
          }
        </span>
      </div>
    </div>
  );
};
